import { HasId } from "src/main/angular/app/shared/basic-data-management/has-id.interface";
import { BasicAccesOrder } from "./basic-acces-order.entity";

export abstract class UpdateAccesOrder extends BasicAccesOrder implements HasId {
	id!: number;

	constructor() {
		super();
	}
}